import {Component} from '@angular/core';

@Component({
  selector: 'evicare-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss'],
})
export class TermsDialogComponent {
}
